import { Suspense } from 'react';
import { CustomErrorBoundary } from './CustomErrorBoundary';
import Loading from './Loading';

// This is where things like ErrorBoundary, Suspense, etc. would go.
export const RouteContentProtection = ({
  fallback = <Loading show containerHeight="100%" />,
  children,
}: {
  fallback?: React.ReactNode;
  children: React.ReactNode;
}) => {
  return (
    <CustomErrorBoundary>
      <Suspense fallback={fallback}>{children}</Suspense>
    </CustomErrorBoundary>
  );
};
